import * as React from 'react'

import { UpsellBlock, UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { GlpButtonBlock } from './GlpButtonBlock'
import { GlpCardBlock } from './GlpCardBlock'
import { GlpFeaturesSectionBlock } from './GlpFeaturesSectionBlock'
import { GlpHeaderBlock } from './GlpHeaderBlock'
import { GlpHeroSectionBlock } from './GlpHeroSectionBlock'
import { GlpRowBlock } from './GlpRowBlock'

interface LandingPageBlocksProps {
  blocks?: UpsellBlock[] | null
  slug: string
  landingPage: UpsellLandingPage
  currentUpsellOrigin: {
    request_source: string
    request_source_category?: string
    request_source_component?: string
  } | null
}

/**
 * LandingPageBlocks component renders blocks in the exact order they appear in DatoCMS.
 * The blocks array from the GraphQL query preserves the order defined in DatoCMS modular content,
 * and we render them sequentially using .map() which maintains that order.
 */
export const LandingPageBlocks: React.FC<LandingPageBlocksProps> = ({
  blocks,
  slug,
  landingPage,
  currentUpsellOrigin,
}) => {
  if (!blocks || blocks.length === 0) {
    return null
  }
  return (
    <>
      {blocks.map((block, index) => {
        if (!block) {
          return null
        }

        // Render blocks in DatoCMS order - the array order matches the CMS order
        if (block.glpButton) {
          return (
            <GlpButtonBlock
              key={`glp-button-${block.glpButton.id}-${index}`}
              block={block.glpButton}
              slug={slug}
              landingPage={landingPage}
              currentUpsellOrigin={currentUpsellOrigin}
            />
          )
        }

        if (block.glpCard) {
          return (
            <GlpCardBlock key={`glp-card-${block.glpCard.id}-${index}`} block={block.glpCard} />
          )
        }

        if (block.glpRow) {
          return <GlpRowBlock key={`glp-row-${block.glpRow.id}-${index}`} block={block.glpRow} />
        }

        if (block.glpHeader) {
          return (
            <GlpHeaderBlock
              key={`glp-header-${block.glpHeader.id}-${index}`}
              block={block.glpHeader}
            />
          )
        }

        if (block.glpHeroSection) {
          return (
            <GlpHeroSectionBlock
              key={`glp-hero-section-${block.glpHeroSection.id}-${index}`}
              block={block.glpHeroSection}
              slug={slug}
              landingPage={landingPage}
              currentUpsellOrigin={currentUpsellOrigin}
            />
          )
        }

        if (block.glpFeaturesSection) {
          return (
            <GlpFeaturesSectionBlock
              key={`glp-features-section-${block.glpFeaturesSection.id}-${index}`}
              block={block.glpFeaturesSection}
            />
          )
        }

        return null
      })}
    </>
  )
}
